import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import type {
  AfsConfig,
  AfsPlacement
} from '@schibsted-nmp/advertising-shared';

type AfsAtom = {
  placements: Array<AfsPlacement>;
  config: AfsConfig | null;
};

export const $afsAtom = atom<$afsAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.Afs,
  {
    placements: [],
    config: null
  }
);

export namespace $afsAtom {
  export type Value = AfsAtom;
}
